module.exports = __webpack_public_path__ + "assets/1b607578a42ffca22c35449726e2946e.png";